<template>
  <van-popup
    v-model="myshow"
    :close-on-click-overlay="false"
    @click-overlay="showBtn"
    :class="themeStyleVs === 2 ? 'take_main black_version_box' : 'take_main'"
  >
    <div>
      <div class="header_box">
        <van-icon name="cross" @click="showBtn" />
      </div>
      <div class="text_main">
        {{ name }}
      </div>
      <div class="tips_box" @click="checkImg">
        <img :src="tsShow ? xzImg : notImg" alt="" />
        <span>今日内不再提示</span>
      </div>
      <div class="btn_box" @click="goLinkFn">已知晓扣豆规则，{{ btnText }}</div>
    </div>
  </van-popup>
</template>
<script>
import mixins from '@/mixins/index.js';
import { jieliuFun } from '@/utils/format.js';
import { setClientRedis } from '@/api/index.js';
export default {
  name: 'takeOut',
  mixins: [mixins],
  props: ['show', 'name', 'btnText', 'type'],
  data() {
    return {
      myshow: this.show,
      notImg: require('../../assets/image/gx_detail.png'),
      xzImg: require('../../assets/image/xz.png'),
      tsShow: false,
      themeStyleVs: 1
    };
  },
  watch: {
    show: {
      handler(newval) {
        this.myshow = newval;
        if (newval) {
          this.tsShow = false;
        }
      }
    }
  },
  filters: {},
  created() {},
  mounted() {
    this.themeStyleVs = Number(this.getUrlQuery('themeStyleVs'));
  },
  methods: {
    checkImg: function () {
      this.tsShow = !this.tsShow;
    },
    showBtn: function () {
      this.tsShow = false;
      this.$emit('cancelBasis', false);
    },
    goLinkFn: jieliuFun(function () {
      if (this.tsShow === true) {
        let type = this.type;
        localStorage.setItem(type, true);
        this.setPropData(type);
      }
      this.$emit('linkGo');
    }, 250),
    setPropData: function (type) {
      let obj = {
        cl: localStorage.getItem('cl'),
        mn: localStorage.getItem('mn'),
        hc: localStorage.getItem('hc'),
        bccl: localStorage.getItem('bccl'),
        openMn: localStorage.getItem('openMn'),
        ccxy: localStorage.getItem('ccxy')
      };
      setClientRedis({ Obj: JSON.stringify(obj) }).then((res) => {
        if (res.err === 200) {
          
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.take_main {
  width: 310px;
  padding: 16px;
  background-color: #fff;
  .header_box {
    width: 100%;
    height: 22px;
    text-align: right;
    color: #222222;
    margin-bottom: 8px;
  }
  .text_main {
    font-size: 14px;
    color: #555;
    margin-bottom: 8px;
  }
  .tips_box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
    img {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
    span {
      color: #999;
      font-size: 12px;
    }
  }
  .btn_box {
    width: 100%;
    height: 40px;
    border-radius: 6px;
    background: #286df7;
    font-size: 14px;
    color: #fff;
    line-height: 40px;
    text-align: center;
  }
}
.van-popup {
  border-radius: 12px;
}
.black_version_box {
  background-color: #181a23;
  .van-popup {
    background-color: #181a23;
  }
  .header_box {
    color: #e4e9fe;
  }
  .text_main {
    color: #aab9d1;
  }
  .tips_box {
    span {
      color: #6b7687;
    }
  }
}
</style>
<style lang="less">
.black_version {
  .van-popup {
    background-color: #181a23;
  }
}
</style>
